import ReviewTableDto from 'app/admin/review/dto/ReviewTableDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class ReviewTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'reviewTableControl';
	}

	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, ReviewTableDto)))
				.catch(reject);
		});
	}
}

export default new ReviewTableService();